import { render, staticRenderFns } from "./ForensicExpertise.vue?vue&type=template&id=5048ba15&"
import script from "./ForensicExpertise.vue?vue&type=script&lang=js&"
export * from "./ForensicExpertise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports